import { Injectable } from '@angular/core';
import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

@Injectable()
export class CustomDateFormatter extends CalendarDateFormatter {
    override dayViewHour({ date, locale }: DateFormatterParams): string {
        return format(date, 'HH:mm', { locale: es });
    }

    override weekViewHour({ date, locale }: DateFormatterParams): string {
        return format(date, 'HH:mm', { locale: es });
    }
}